var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: { followCursor: true, placement: "bottom-end" },
          expression: "{ followCursor: true, placement: 'bottom-end' }",
        },
      ],
      staticClass: "status-container",
      attrs: { content: _vm.rawStatus },
    },
    [
      _c("div", { staticClass: "status-circle", class: _vm.statusClass }),
      _vm._v(" "),
      _c("span", { staticClass: "status-text", class: _vm.statusClass }, [
        _vm._v("\n        " + _vm._s(_vm.statusText) + "\n    "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }